import template from './radniNalogList.html';
import ListController from '../common/list.controller.js';

class RadniNalogListController extends ListController {
    constructor(DS, AppConfiguration, $q, $state) {
        super(DS.definitions.RadniNalog);
        this.datastore = () => DS;
        this.$q = $q;
        this.$state = $state;
        this.view = AppConfiguration().getViewByEntityAndType('RadniNalog', 'ListView');

        this.icon = this.view.icon();
        this.pageTitle = this.view.title();
        this.pageDesc = this.view.description();
    }

    $onInit() {
        this.items = [];
        this.getState();
    }

    getState() {
        this.resolveReferences().then(() => {
            this.getItems();
        });
    }

    resolveReferences() {
        let models = [];
        let datastore = this.datastore();

        _.forOwn(this.view.getReferences(), (value, key) => {
            models.push(datastore.definitions[value.targetEntity().name()]);
        });

        return this.$q.all(models.map(m => m.findAll()));
    }

    getQueryset(params) {
        return this.Model.findAll(params, { bypassCache: true });
    }

    edit(item) {
        this.$state.go('radniNalog.details', { id: item.id });
    }
}

RadniNalogListController.$inject = ['DS', 'AppConfiguration', '$q', '$state'];

const RadniNalogListComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: RadniNalogListController,
    controllerAs: 'vm'
};

export { RadniNalogListComponent };
export { RadniNalogListController };



// WEBPACK FOOTER //
// ./app/components/radniNalog/radniNalogList.component.js